<template>
  <div class="card">
    <header class="bandeau-modal card-header"></header>
    <div class="card-content">
      <section class="has-text-centered column is-12">
          <span class="is-size-3 has-text-weight-bold">
            {{ $t('general.popUpChangementCommercial.title') }}
          </span>
      </section>
      <div class="column is-12" v-if="messagesPopup.length > 0">
        <error-msg-component :messages="messagesPopup"
                             :error="messagesPopup.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="messagesPopup = []"/>
      </div>
      <div class="column is-12">
        <user-selector
          v-model="commercialId"
          @input="setCommercial"
          :critere="(u) => [constantes.COMMERCIAL, constantes.DIRECTEUR_COMMERCIAL]
            .includes(u.profil)"
          :placeholder="$t('general.popUpChangementCommercial.informations.aucunCommercial')"
          :label="$t('general.popUpChangementCommercial.informations.trade')"
          :disabled="false"
          :obligatoire="commercialObligatoire"
        />
      </div>

      <main>
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered mg-button-modal"
            @click="handleCancel()"
          >
            {{ $t('general.popUpChangementCommercial.actions.cancel') }}
          </button>
          <button
            class="button is-warning has-text-centered mg-button-modal"
            id="button-validate"
            :disabled="!commercialId && commercialObligatoire"
            @click="handleApply()"
          >
            {{ $t('general.popUpChangementCommercial.actions.valider') }}
          </button>
        </div>
      </main>
    </div>
    <b-modal v-model="showConfirmation" has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('general.popUpChangementCommercial.messageConfirmation')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="showConfirmation = false"
        @yes="saveChangementCommercial">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import errorMsgComponent from '@/components/general/errorMsgComponent';
import { createNamespacedHelpers } from 'vuex';
import { DIRECTEUR_COMMERCIAL, COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import userSelector from '@/components/commun/user/userSelector';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { EditAllCommercial } from '@/api/devisCommandeFacture';
import validation from '@/services/catalogue/validation/validationPopupChangementCommercial';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'popUpChangementCommercial',
  components: {
    userSelector,
    popUpPrevention,
    errorMsgComponent,
  },
  props: {
    isDevis: {
      type: Boolean,
      required: false,
    },
    elementsSelectionnes: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      messagesPopup: [],
      commercialSearch: '',
      showConfirmation: false,
      commercialId: null,
      constantes: {
        COMMERCIAL,
        DIRECTEUR_COMMERCIAL,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    commercialObligatoire() {
      if (this.isDevis) {
        return false;
      }
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS
          .rendreObligatoireAssistantEtCommercialSurCommandeFacture.key);
    },
  },
  methods: {
    confirmAction() {
      this.showConfirmation = false;
    },
    handleCancel() {
      this.$emit('close');
    },
    handleApply() {
      this.showConfirmation = true;
    },
    setCommercial(commercialId) {
      this.commercialId = commercialId;
    },
    async saveChangementCommercial() {
      if (this.modulePresseActive) return;
      if (this.elementsSelectionnes.length === 0) return;
      this.messagesPopup = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await EditAllCommercial({
          ids: this.elementsSelectionnes.map(e => e.id),
          commercialId: this.commercialId,
        });
        this.$emit('onEditAllCommercialUpdated');
        loadingComponent.close();
      } catch (e) {
        this.showConfirmation = false;
        if (e.response.data.error) {
          validation(e.response, this.messagesPopup);
          this.isErrorPopup = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
};
</script>
